<template>
    <div class="form">
        <el-form style="margin:20px;width:60%;min-width:600px;" label-width="110px">
            <el-form-item class='edit-form' label="单品名称" required>
                <el-input placeholder='请输入单品名称(必填)' v-model='Form.ProName' v-show="this.isEdit"></el-input>
                <span v-show="!this.isEdit" class="spanitem"> {{Form.ProName}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="单品简称" required>
                <el-input placeholder='请输入单品简称(必填)' v-model='Form.ProNick' v-show="this.isEdit"></el-input>
                <span v-show="!this.isEdit" class="spanitem"> {{Form.ProNick}}</span>
            </el-form-item>
            <el-form-item class='edit-form' label="单品编号" required>
                <el-input placeholder='请输入单品编号(必填)' v-model='Form.ProCode' v-show="this.isEdit"></el-input>
                <span v-show="!this.isEdit" class="spanitem">{{Form.ProCode}}</span>
            </el-form-item>
            <el-form-item label="项目" required>
                <el-select placeholder="-请选择-" v-model='Form.ProSubjection' v-show="this.isEdit">
                    <el-option v-for="option in ProSubjectionNames" :key="option.id" :value="option.id" :label="option.name">
					</el-option>
                </el-select>
                <span v-show="!this.isEdit" class="spanitem">{{Form.ProSubjectionName}}</span>
            </el-form-item>
            <el-form-item label="类型" required>
                <el-select placeholder="-请选择-" v-model='Form.ProTypeId' v-show="this.isEdit">
                    <el-option v-for="option in ProTypeNames" :value="option.Id" :label="option.ParmName">
					</el-option>
                </el-select>
                <span v-show="!this.isEdit" class="spanitem">{{Form.ProTypeName}}</span>
            </el-form-item>
            <el-form-item label="发货仓库类型" required>
                <el-select placeholder="-请选择-" v-model='Form.StockType' v-show="this.isEdit">
                    <el-option v-for="option in StockTypeNames" :value="option.id" :label="option.name">
					</el-option>
                </el-select>
                <span v-show="!this.isEdit" class="spanitem">{{Form.StockTypeName}}</span>
            </el-form-item>
            <el-form-item label="自然单位" required>
                <el-select placeholder="-请选择-" v-model="activenaturalUnits" v-show="this.isEdit">
                    <el-option v-for="option in naturalUnits" :value="option.Id" :label="option.ParmName">
                    </el-option>
                </el-select>
                <el-button icon="plus" @click="mydialog(6)" v-show="this.isEdit"></el-button>
                <span v-show="!this.isEdit" class="spanitem">{{Form.ProNaturalUnitName}}</span>
            </el-form-item>
            <el-form-item label="销售单位" required>
                <el-select placeholder="-请选择-" v-model="activesaleUnits" v-show="this.isEdit">
                    <el-option v-for="option in saleUnits" :value="option.Id" :label="option.ParmName">
                    </el-option>
                </el-select>
                <el-button icon="plus" @click="mydialog(7)" v-show="this.isEdit"></el-button>
                <span v-show="!this.isEdit" class="spanitem">{{Form.ProSaleUnitName}}</span>
            </el-form-item>
            <el-form-item style="width:500px;margin-left: -2px" label="比例" required>
                <el-row v-show="this.isEdit">
                    <el-col :span="6">
                        <el-input v-model='Form.ProProportion1'></el-input>
                    </el-col>
                    <el-col :span="4" style="margin-left:2px" v-show='Form.ProNaturalUnit'>
                        <span v-show="this.isEdit">({{Form.ProNaturalUnit}})</span>
                    </el-col>
    
                    <el-col :span="2">等于</el-col>
                    <el-col :span="6">
                        <el-input v-model='Form.ProProportion2'></el-input>
                    </el-col>
                    <el-col :span="4" style="margin-left: 2px" v-show='Form.ProSaleUnit'>
                        <span v-show="this.isEdit">({{Form.ProSaleUnit}})</span>
                    </el-col>
                </el-row>
                <el-row v-show="!this.isEdit">
                    <el-col :span="6" style="margin-left: 25px;width: 60%">
                        <span style="margin-right: 10px">{{Form.ProProportion1}}({{Form.ProNaturalUnit}})</span>
                        等于
                        <span style="margin-left: 10px"> {{Form.ProProportion2}}({{Form.ProSaleUnit}})</span>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="备注">
                <el-input type="textarea" placeholder="请输入备注(选填)" v-model='Form.ProRemark' v-show="this.isEdit"></el-input>
                <span v-show="!this.isEdit" class="spanitem">
                    <span v-if="Form.ProRemark!=undefined&&Form.ProRemark!=''">{{Form.ProRemark}}</span>
                    <span v-else>--</span>
                </span>
            </el-form-item>
            <el-row>
                <el-col :span="24" style="display: flex;justify-content: center;margin-bottom: 20px;">
                    <el-button type="primary" @click='submit'>确定</el-button>
                </el-col>
            </el-row>
        </el-form>
        <el-dialog :title="table.title" v-model="visibleShow" size="tiny" :close-on-click-modal="false" v-on:close="dialogClosed">
            <el-table :data="table.data" style="width: 100%">
                <el-table-column prop="ParmName" :label="table.label" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template scope="scope">
                        <el-button size="small" icon="delete" type="danger" @click="delTable(scope.$index, scope.row,table.type)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-row>
                    <el-col :span="16" style="margin-left: 20px">
                        <el-input v-model="dialogContent"></el-input>
                    </el-col>
                    <el-col :span="6">
                        <el-button type="primary" @click="addDialog(table.type)">添 加</el-button>
                    </el-col>
                </el-row>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import ProductAdd from './ProductAdd.js';
module.exports = ProductAdd;
</script>

<style scoped>
.edit-form {
    width: 370px;
}

.ImgPreList {
    width: 80px;
    height: 80px;
    margin: 0 5px 5px 0;
    float: left;
    z-index: 999;
    list-style-type: none;
}

#IconImg {
    margin-left: 21px;
}

.spanitem {
    margin-left: 25px;
}

.a {
    margin-left: 25px;
}



/*----------*/

#container1 {
    width: 335px;
}

#ImgPrev {
    float: left;
    margin-right: 5px;
    width: 80px;
    height: 80px;
    position: relative;
    margin-bottom: 6px;
}

.post-format-content {
    position: relative;
    background: white;
}

.post-thumbnail {
    max-width: 100%;
    height: auto;
    overflow: hidden;
}

.content-wrap {
    padding: 0;
    position: absolute;
    text-align: center;
    width: 100%;
    top: 0;
    bottom: 0;
    display: table-cell;
    vertical-align: middle;
    overflow: hidden;
    border-radius: 8px;
}

.entry-title {
    display: table;
    font-size: 110%;
    height: 100%;
    width: 100%;
    margin: 0;
}

.edit-link {
    z-index: 2;
}

.featured-image {
    display: table-cell;
    position: relative;
    /*       transition: opacity .25s ease-in-out, background .25s ease-in-out;
        -moz-transition: opacity .25s ease-in-out, background .25s ease-in-out;
        -webkit-transition: opacity .25s ease-in-out, background .25s ease-in-out;*/
    vertical-align: middle;
    z-index: 1;
    color: #fff;
    text-decoration: none;
    opacity: 0;
    padding: 10%;
}

.featured-image:hover {
    border-radius: 8px;
    opacity: 0.9;
    color: #fff;
    background: rgba(0, 0, 0, 0.8);
}

.post-thumbnail img {
    display: block;
}

img {
    max-width: 100%;
    height: auto;
}

#myProPic {
    width: 80px;
    height: 80px;
    border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// ProductAdd.vue?6f10c066